<template>
  <HeaderContent title="Schedule" />
  <ActionContent
    ctaText="Add Schedule"
    @action="modal = !modal"
    :filterDate="false"
    @filter-change="onFilterChange"
    @search-query="searchData"
  />
  <ScheduleConfirm
    title="Confirmation"
    :uuid="scheduleUuid"
    v-model="modalConfirm"
    @confirmed="deleteData"
  >
    <template #text>Are you sure to delete this data ?</template>
  </ScheduleConfirm>
  <ScheduleStatistics title="Schedule Statistics" :data="statistics" />
  <ScheduleForm
    :modal="modal"
    :scheduleData="schedule"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <ScheduleDataTable
    :data="schedules"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import { ref, inject, onMounted } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import ScheduleForm from "./ScheduleForm.vue";
import ScheduleStatistics from "@/components/StatisticData.vue";
import ScheduleDataTable from "@/components/DataTable.vue";
import ScheduleConfirm from "@/components/ModalDialog.vue";
// import iconToday from "../../../../public/icons/sun.svg";
import iconUser from "../../../../public/icons/users-alt.svg";
import iconRoomCategory from "../../../../public/icons/dorm-room.svg";
// import iconWeek from "../../../../public/icons/week.svg";
import iconRoom from "../../../../public/icons/brand.svg";
import iconHousekeeping from "../../../../public/icons/hand-cleaning.svg";

export default {
  name: "ScheduleIndex",
  components: {
    HeaderContent,
    ActionContent,
    ScheduleForm,
    ScheduleConfirm,
    ScheduleStatistics,
    ScheduleDataTable,
  },
  setup() {
    const repositories = inject("repositories");
    const scheduleRepository = repositories ? repositories.schedule : null;
    const schedules = ref([]);
    const schedule = ref({});
    const scheduleUuid = ref(null);
    const currentPage = ref(1);
    const modal = ref(false);
    const modalConfirm = ref(false);
    // const data = ref([
    //   {
    //     type_room: "Deluxe",
    //     no_room: "A3",
    //     housekeeping: "Budi",
    //     // reservation_status: 'checkin',
    //   },
    //   {
    //     type_room: "Super Deluxe",
    //     no_room: "A1",
    //     housekeeping: "Andi",
    //     // reservation_status: 'checkin',
    //   },
    //   {
    //     type_room: "Honeymoon",
    //     no_room: "A2",
    //     housekeeping: "Rahmat",
    //     // reservation_status: 'checkin',
    //   },
    //   {
    //     type_room: "Studio",
    //     no_room: "A4",
    //     housekeeping: "Siti",
    //     // reservation_status: 'checkin',
    //   },
    //   {
    //     type_room: "Family",
    //     no_room: "A5",
    //     housekeeping: "Nur",
    //     // reservation_status: 'checkin',
    //   },
    // ]);
    const headers = ref([
      {
        key: "no",
        label: "#",
      },
      {
        key: "housekeeping",
        label: "Housekeeping Name",
        sortable: true,
      },
      {
        key: "schedule",
        label: "Schedule",
        sortable: true,
      },
      {
        key: "type_room",
        label: "Room Type",
        sortable: true,
      },
      {
        key: "no_room",
        label: "Room Number",
        sortable: true,
      },
      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      // {
      //   label: "Detail",
      //   variant: "success",
      //   icon: "fas fa-file-alt",
      //   action: (item) => {
      //     console.log("Detail action clicked for:", item);
      //   },
      // },
      {
        label: "Reschedule",
        variant: "warning",
        icon: "fas fa-calendar-day",
        action: (item) => {
          getById(item.uuid);
          console.log("Reschedule action clicked for:", item);
          // Implement your Reschedule logic here
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
          console.log("Delete action clicked for:", item);
          console.log("Schedule UUID yang akan dihapus:", scheduleUuid.value);
          // Implement your Delete logic here
        },
      },
    ]);
    const statistics = ref([]);

    const getAll = async (searchQuery = "") => {
      const params = {};

      if (searchQuery) params.search = searchQuery;
      try {
        await scheduleRepository.getAll().then((res) => {
          schedules.value = res.data.data.map((item, index) => ({
            no: index + 1,
            uuid: item.uuid,
            housekeeping: item.employee?.fullname ?? "-",
            // type_room: item.room_category?.name ?? "-",
            type_room: (item.room_category ?? [])
              .map((rc) => rc?.name ?? "-")
              .join(", "),
            // no_room: (item.room_categories ?? [])
            //   .flatMap((rc) => (rc?.rooms ?? []).map((r) => r?.code ?? "-"))
            //   .join(", "),

            no_room: Array.from(
              new Set(
                (item.room_category ?? []).flatMap((rc) =>
                  (rc?.rooms ?? []).map((r) => r?.code ?? "-")
                )
              )
            ).join(", "),
            // no_room: item.room?.code ?? "-",
            schedule: item.schedule,
          }));

          statistics.value = [
            {
              label: "Total",
              key: "Staff",
              value: res.data.data.length,
              color: "primary",
              icon: iconUser,
            },
            {
              label: "Total",
              key: "Room Type",
              value: res.data.statistics.roomCategory,
              color: "primary",
              icon: iconRoomCategory,
            },
            {
              label: "Total",
              key: "Room",
              value: res.data.statistics.room,
              color: "primary",
              icon: iconRoom,
            },
            {
              label: "Total",
              key: "Housekeeping",
              value: res.data.data.length,
              color: "primary",
              icon: iconHousekeeping,
            },
          ];
        });
      } catch (err) {
        console.error("Failed to fetch schedule data:", err);
      }
    };

    const getById = async (uuid) => {
      try {
        console.log("Fetching schedule by uuid:", uuid);
        const res = await scheduleRepository.getById(uuid);
        console.log("Raw data received:", res.data);
        const raw = res.data;
        console.log("schedule uuid: ", raw.uuid);
        schedule.value = {
          uuid: raw.uuid,
          schedule: raw.schedule,
          employee: {
            uuid: raw.employee?.uuid ?? null,
            fullname: raw.employee?.fullname ?? "",
          },
          room_category: (raw.room_category || []).map((category) => ({
            uuid: category.uuid,
            name: category.name,
            rooms: (category.rooms || []).map((room) => ({
              uuid: room.uuid,
              code: room.code,
            })),
          })),
        };

        modal.value = true;
      } catch (err) {
        console.error("Failed to fetch schedule by id:", err);
      }
    };

    const updateModal = (newValue) => {
      modal.value = newValue;
      schedule.value = {};
    };
    const showConfirmModal = async (uuid) => {
      modalConfirm.value = true;
      scheduleUuid.value = uuid;
      console.log(scheduleUuid.value);
    };
    const deleteData = async () => {
      await scheduleRepository
        .delete(scheduleUuid.value)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const searchData = async (keyword) => {
      getAll(keyword);
    };
    onMounted(() => {
      getAll();
    });
    return {
      modal,
      headers,
      statistics,
      customActions,
      // data,
      getAll,
      getById,
      schedule,
      schedules,
      scheduleUuid,
      currentPage,
      modalConfirm,
      deleteData,
      showConfirmModal,
      updateModal,
      searchData,
    };
  },
};
</script>

<style></style>
